<script setup lang="ts">
import { Monitor, Moon, Sun } from 'lucide-vue-next';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


import { useTheme } from '@/composables/useTheme.js';

/**
 * Переключатель темы: система → светлая → тёмная → система.
 *
 * Одна кнопка вместо трёх: тема — редко меняемая настройка, ряд из трёх
 * переключателей занимал бы место в топбаре постоянно. Текущее состояние
 * читается иконкой и озвучивается в aria-label, поэтому цикл остаётся
 * понятным и на скринридере.
 */
const { t } = useI18n();
const { pref, cycle } = useTheme();

const icon = computed(() => (pref.value === 'system' ? Monitor : pref.value === 'light' ? Sun : Moon));
const label = computed(() => t(`theme.${pref.value}`));
</script>

<template>
  <button type="button"
class="theme-toggle"
:aria-label="label"
:title="label"
@click="cycle">
    <component :is="icon"
:size="18"
:stroke-width="1.75"
aria-hidden="true" />
  </button>
</template>

<style scoped>
.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background var(--transition-fast), color var(--transition-fast);
}

.theme-toggle:hover {
  background: var(--color-bg-muted);
  color: var(--color-text);
}
</style>
